var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Header'),(Number(_vm.userInfo.is_active_course)!==1)?_c('Noauth'):_vm._e(),(Number(_vm.userInfo.is_active_course)===1)?_c('Course'):_vm._e(),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }